import { createSelector } from "reselect";

export const getGames = (state) => state.game.minigames;
export const getMinigame = (instance, uid) => {
  return instance.minigames.find((game) => game.uid === uid);
};

export const getTotalTime = createSelector(getGames, (minigames) => {
  return minigames?.reduce((acc, minigame) => acc + minigame.time, 0);
});

export const getGamesWithProgress = createSelector(
  getGames,
  (state) => state.forms?.clusterprofile?.data?.layers,
  (state) => state.game.progress,
  (state) => state.game.activeGameId,
  (minigames, currentProgress = [], overallProgress, activeGameId) => {
    return minigames.map((game) => {
      const progress = overallProgress[game.uid] || currentProgress;
      const requirementsProgress = game.requirements.map((layer) => {
        const comparison = progress.find(({ type }) => {
          return layer.type === type;
        });

        if (!comparison) {
          return false;
        }

        const { displayName, type, packUid, ...requirements } = layer;

        return Object.keys(requirements).every((key) => {
          if (key === "values") {
            return true;
          }
          const isSame = requirements[key] === comparison.config?.[key];
          if (key === "version") {
            return isSame || requirements[key] === comparison.config?.tag;
          }

          return isSame;
        });
      });

      return {
        ...game,
        isGameActive: activeGameId === game.uid,
        totalSubtasks: game.requirements.length,
        isGameCompleted: requirementsProgress.every(Boolean),
        requirements: game.requirements.map((req, index) => ({
          ...req,
          isCompleted: requirementsProgress[index],
        })),
      };
    });
  },
);

export const isGameCompleted = createSelector(
  getGamesWithProgress,
  (minigames) => {
    const allRequirements = minigames.reduce(
      (acc, minigame) => [...acc, ...minigame.requirements],
      [],
    );
    return allRequirements.every((req) => req.isCompleted);
  },
);

export const getActiveGame = createSelector(
  getGames,
  (state) => state.game.activeGameId,
  (minigames, activeGameId) => {
    if (!minigames.length) {
      return {};
    }
    return minigames.find((minigame) => activeGameId === minigame.uid);
  },
);

export const getTotalProgress = createSelector(
  getGamesWithProgress,
  (minigames) => {
    const allRequirements = minigames.reduce(
      (acc, minigame) => [...acc, ...minigame.requirements],
      [],
    );
    const tasksCompleted = allRequirements.filter((req) => req.isCompleted);
    return (tasksCompleted.length / allRequirements.length) * 100;
  },
);

export const getMinigameTotalProgress = createSelector(
  getMinigame,
  (minigame) => minigame.layers.length,
);

export const getUserProgress = createSelector(
  (state) => {},
  (data) => {},
);
